// Base de conocimiento de servicios IntelliGrow
export const SERVICES_KNOWLEDGE = `
# IntelliGrow - Servicios de Inteligencia Artificial

## Información General
- Empresa: IntelliGrow AI Agency
- Email: admin@intelligrow.shop
- Calendly: https://calendly.com/intelligroow-nvmb/30min
- Alcance: Todo el Mundo (100% Remoto)
- Soporte: 24/7

## Servicios Disponibles

### 1. CONSULTORÍA AI
**Descripción**: Asesoramiento estratégico para implementar IA en tu empresa.
**Ideal para**: Empresas que quieren empezar con IA pero no saben por dónde.
**Incluye**:
- Análisis de procesos actuales
- Identificación de oportunidades de automatización
- Roadmap de implementación
- Estimación de ROI
- Acompañamiento en la ejecución
**Precio**: Consultar
**Duración**: 2-4 semanas
**Enlace**: https://intelligrow.shop/servicios/consultoria

### 2. CHATBOT CON CREWAI (Premium)
**Descripción**: Chatbot avanzado con arquitectura multi-agente, 100% personalizado.
**Ideal para**: Empresas que necesitan soluciones complejas y a medida.
**Tecnología**: CrewAI + Python + LangChain
**Características**:
- Arquitectura modular (ajustable con muchos parámetros)
- Razonamiento avanzado
- Memoria persistente
- Integración con bases de datos propias
- Flujos de trabajo complejos
- Código 100% tuyo (sin vendor lock-in)
**Ventajas**: Máxima personalización, escalabilidad, control total
**Precio**: Premium (mayor inversión)
**Duración**: 4-8 semanas
**Enlace**: https://intelligrow.shop/servicios/chatbot-crewai

### 3. CHATBOT CON N8N (Rápido y Económico)
**Descripción**: Chatbot visual con n8n, ideal para implementación rápida.
**Ideal para**: Empresas que necesitan solución rápida y económica.
**Tecnología**: n8n (low-code) + APIs
**Características**:
- Desarrollo visual (sin código complejo)
- Integración con +200 apps
- Despliegue rápido (1-2 semanas)
- Mantenimiento simplificado
- Flujos de trabajo automatizados
**Ventajas**: Rápido, económico, fácil de mantener
**Precio**: Económico (menor inversión)
**Duración**: 1-2 semanas
**Enlace**: https://intelligrow.shop/servicios/chatbot-n8n

### 4. AUTOMATIZACIÓN DE PROCESOS
**Descripción**: Automatización de tareas repetitivas y flujos de trabajo.
**Ideal para**: Empresas con procesos manuales que consumen tiempo.
**Casos de uso**:
- Automatización de emails
- Sincronización entre CRMs
- Procesamiento de documentos
- Generación de reportes
- Notificaciones automáticas
**Tecnología**: n8n, Zapier, Make, Python
**ROI**: Ahorro de 20-40 horas/semana
**Precio**: Según complejidad
**Duración**: 1-3 semanas
**Enlace**: https://intelligrow.shop/servicios/automatizacion

### 5. CREW DE AGENTES AUTÓNOMOS
**Descripción**: Sistema multi-agente que trabaja en equipo para resolver problemas complejos.
**Ideal para**: Empresas con procesos que requieren múltiples pasos y decisiones.
**Características**:
- Múltiples agentes especializados
- Coordinación automática
- Toma de decisiones autónoma
- Ejecución de tareas complejas
- Aprendizaje continuo
**Casos de uso**:
- Análisis de mercado
- Generación de contenido
- Investigación automatizada
- Procesamiento de datos complejos
**Precio**: Premium
**Duración**: 6-12 semanas
**Enlace**: https://intelligrow.shop/servicios/agents-crew

### 6. AUTOMATIZACIÓN AIRBNB & BOOKING
**Descripción**: Agente especializado para gestionar reservas de propiedades.
**Ideal para**: Propietarios de Airbnb, hoteles, apartamentos turísticos.
**Características**:
- Responde consultas 24/7
- Gestiona disponibilidad en tiempo real
- Procesa reservas automáticamente
- Envía confirmaciones
- Maneja cancelaciones
- Integración con calendarios
**Tecnología**: RAG + CrewAI + APIs de Airbnb/Booking
**ROI**: Aumenta reservas 30-45%
**Precio**: Según volumen de propiedades
**Duración**: 3-4 semanas
**Enlace**: https://intelligrow.shop/servicios/airbnb-booking

## Comparación: CrewAI vs n8n

### Elige CrewAI si:
- Necesitas lógica compleja y razonamiento avanzado
- Quieres máxima personalización
- Tienes presupuesto para inversión premium
- Necesitas escalabilidad a largo plazo
- Quieres código 100% tuyo

### Elige n8n si:
- Necesitas solución rápida (1-2 semanas)
- Presupuesto limitado
- Flujos de trabajo simples
- Integración con apps existentes
- Mantenimiento fácil

## Proceso de Trabajo

1. **Consulta Inicial** (Gratis)
   - Agendar: https://calendly.com/intelligroow-nvmb/30min
   - Duración: 30 minutos
   - Analizamos tu caso

2. **Propuesta**
   - Solución recomendada
   - Presupuesto detallado
   - Timeline
   - ROI estimado

3. **Desarrollo**
   - Sprints semanales
   - Demos regulares
   - Feedback continuo

4. **Despliegue**
   - Implementación en producción
   - Capacitación del equipo
   - Documentación completa

5. **Soporte**
   - Soporte 24/7
   - Mantenimiento incluido
   - Actualizaciones

## Tecnologías que Dominamos

- Python
- SQL & PostgreSQL
- Machine Learning
- CrewAI & LangChain
- Deep Learning
- Reinforcement Learning
- Robotics
- n8n
- APIs & Integraciones

## Casos de Éxito

### Chatbot para Entrenadores
- Automatización de rutinas y dietas vía WhatsApp
- Resultado: +45% retención de clientes en 3 meses

### Automatización de Reservas
- Gestión 24/7 de propiedades Airbnb
- Resultado: +30% en reservas, -60% tiempo de gestión

## Preguntas Frecuentes

**¿Cuánto cuesta?**
Depende del servicio. n8n es más económico (desde €2,000), CrewAI es premium (desde €8,000).

**¿Cuánto tarda?**
- n8n: 1-2 semanas
- CrewAI: 4-8 semanas
- Automatización: 1-3 semanas

**¿Necesito conocimientos técnicos?**
No. Nosotros nos encargamos de todo.

**¿El código es mío?**
Sí, especialmente con CrewAI. Sin vendor lock-in.

**¿Dan soporte después?**
Sí, soporte 24/7 incluido.

**¿Trabajan con empresas fuera de España?**
Sí, trabajamos con todo el mundo, 100% remoto.

## Contacto

- **Email**: admin@intelligrow.shop
- **Agendar llamada**: https://calendly.com/intelligroow-nvmb/30min
- **Formulario**: https://intelligrow.shop/empresa/contacto
- **Blog**: https://intelligrow.shop/empresa/blog

## Próximos Pasos

1. Agenda una llamada gratuita: https://calendly.com/intelligroow-nvmb/30min
2. O escríbenos: admin@intelligrow.shop
3. Analizamos tu caso
4. Te enviamos propuesta personalizada
5. ¡Empezamos a trabajar!
`;
